import { render, staticRenderFns } from "./CalculateSalaryProcessLevyBesExcluded.vue?vue&type=template&id=8a6c4dac&"
import script from "./CalculateSalaryProcessLevyBesExcluded.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessLevyBesExcluded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports